import { useHotkeys } from 'react-hotkeys-hook';

import { usePlayerStore } from '../components/PlayerContextProvider';

export type UsePlayerPercentageSeekShortcutParams = {
  /**
   * The scope for the percentage seek shortcut.
   * @see https://github.com/JohannesKlauss/react-hotkeys-hook?tab=readme-ov-file#scopes
   */
  scope: string;
};

export const usePlayerPercentageSeekShortcut = ({ scope }: UsePlayerPercentageSeekShortcutParams) => {
  const videoElement = usePlayerStore((store) => store.videoElement);

  useHotkeys(
    '0,1,2,3,4,5,6,7,8,9',
    ({ key }) => {
      const parsedKey = parseInt(key, 10);

      if (Number.isInteger(parsedKey) && videoElement) {
        const percentage = parsedKey / 10;

        videoElement.currentTime = (videoElement.duration || 0) * percentage;
      }
    },
    {
      description: 'Seek to a specific percentage of the video',
      enabled: !!videoElement,
      preventDefault: true,
      scopes: [scope],
    },
    [videoElement, scope],
  );
};
